import React from 'react';
import ReactDOM from 'react-dom/client';
import "./styles/global.scss";
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import MembershipType from "./screens/MembershipTypes";
import TrackStatus from "./screens/status";
import SuppInfo from "./screens/suppinfo";
import AlumniMain from "./screens/alumni/Main";
import AlumniDeclaration from "./screens/alumni/Declaration";
import AlumniNewForm from "./screens/alumni/NewForm";
import AlumniNewConfirmation from "./screens/alumni/NewFormConfirmation";
import AlumniCompletion from "./screens/alumni/Completion";
import AlumniRenewLogin from "./screens/alumni/RenewLogin";
import AlumniRenewForm from "./screens/alumni/RenewForm";
import AlumniRenewFormConfirmation from "./screens/alumni/RenewFormConfirmation";
import AlumniReplLogin from "./screens/alumni/ReplLogin";
import AlumniReplForm from "./screens/alumni/ReplForm";
import AlumniReplFormConfirmation from "./screens/alumni/ReplFormConfirmation";
import TeacherMain from "./screens/teacher/Main";
import TeacherDeclaration from "./screens/teacher/Declaration";
import TeacherNewForm from "./screens/teacher/NewForm";
import TeacherNewFormConfirmation from "./screens/teacher/NewFormConfirmation";
import TeacherCompletion from "./screens/teacher/Completion";
import TeacherRenewLogin from "./screens/teacher/RenewLogin";
import TeacherRenewForm from "./screens/teacher/RenewForm";
import TeacherRenewFormConfirmation from "./screens/teacher/RenewFormConfirmation";
import TeacherReplLogin from "./screens/teacher/ReplLogin";
import TeacherReplForm from "./screens/teacher/ReplForm";
import TeacherReplFormConfirmation from "./screens/teacher/ReplFormConfirmation";
import IndividualMain from "./screens/individual/Main";
import IndividualDeclaration from "./screens/individual/Declaration";
import IndividualNewForm from "./screens/individual/NewForm";
import IndividualNewFormConfirmation from "./screens/individual/NewFormConfirmation";
import IndividualCompletion from "./screens/individual/Completion";
import IndividualRenewLogin from "./screens/individual/RenewLogin";
import IndividualRenewForm from "./screens/individual/RenewForm";
import IndividualRenewFormConfirmation from "./screens/individual/RenewFormConfirmation";
import IndividualReplLogin from "./screens/individual/ReplLogin";
import IndividualReplForm from "./screens/individual/ReplForm";
import IndividualReplFormConfirmation from "./screens/individual/ReplFormConfirmation";
import OrganisationMain from "./screens/organisation/Main";
import OrganisationDeclaration from "./screens/organisation/Declaration";
import OrganisationNewForm from "./screens/organisation/NewForm";
import OrganisationNewFormConfirmation from "./screens/organisation/NewFormConfirmation";
import OrganisationCompletion from "./screens/organisation/Completion";
import OrganisationRenewLogin from "./screens/organisation/RenewLogin";
import OrganisationRenewForm from "./screens/organisation/RenewForm";
import OrganisationRenewFormConfirmation from "./screens/organisation/RenewFormConfirmation";
import OrganisationReplLogin from "./screens/organisation/ReplLogin";
import OrganisationReplForm from "./screens/organisation/ReplForm";
import OrganisationReplFormConfirmation from "./screens/organisation/ReplFormConfirmation";
import SchoolMain from "./screens/school/Main";
import SchoolDeclaration from "./screens/school/Declaration";
import SchoolNewForm from "./screens/school/NewForm";
import SchoolNewFormConfirmation from "./screens/school/NewFormConfirmation";
import SchoolCompletion from "./screens/school/Completion";
import SchoolRenewLogin from "./screens/school/RenewLogin";
import SchoolRenewForm from "./screens/school/RenewForm";
import SchoolRenewFormConfirmation from "./screens/school/RenewFormConfirmation";
import SchoolReplLogin from "./screens/school/ReplLogin";
import SchoolReplForm from "./screens/school/ReplForm";
import SchoolReplFormConfirmation from "./screens/school/ReplFormConfirmation";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <BrowserRouter basename={"/lem-app"}>
    <Routes>
      <Route path="/" element={<MembershipType />} />
      <Route path="/supp-info/:token" element={<SuppInfo />} />
      <Route path="/alumni">
        <Route index element={<AlumniMain />} />
        <Route path="status" element={<TrackStatus mType={"alumni"} />} />
        <Route path="app/new">
          <Route index element={<AlumniDeclaration appType={"new"} />} />
          <Route path="form" element={<AlumniNewForm />} />
          <Route path="confirmation" element={<AlumniNewConfirmation />} />
          <Route path="completion" element={<AlumniCompletion />} />
        </Route>
        <Route path="app/renew">
          <Route index element={<AlumniRenewLogin />} />
          <Route path="form" element={<AlumniRenewForm />} />
          <Route
            path="confirmation"
            element={<AlumniRenewFormConfirmation />}
          />
          <Route path="completion" element={<AlumniCompletion />} />
        </Route>
        <Route path="app/repl">
          <Route index element={<AlumniReplLogin />} />
          <Route path="form" element={<AlumniReplForm />} />
          <Route path="confirmation" element={<AlumniReplFormConfirmation />} />
          <Route path="completion" element={<AlumniCompletion />} />
        </Route>
      </Route>

      <Route path="/teacher">
        <Route index element={<TeacherMain />} />
        <Route path="status" element={<TrackStatus mType={"teacher"} />} />
        <Route path="app/new">
          <Route index element={<TeacherDeclaration appType={"new"} />} />
          <Route path="form" element={<TeacherNewForm />} />
          <Route path="confirmation" element={<TeacherNewFormConfirmation />} />
          <Route path="completion" element={<TeacherCompletion />} />
        </Route>
        <Route path="app/renew">
          <Route index element={<TeacherRenewLogin />} />
          <Route path="form" element={<TeacherRenewForm />} />
          <Route
            path="confirmation"
            element={<TeacherRenewFormConfirmation />}
          />
          <Route path="completion" element={<TeacherCompletion />} />
        </Route>
        <Route path="app/repl">
          <Route index element={<TeacherReplLogin />} />
          <Route path="form" element={<TeacherReplForm />} />
          <Route
            path="confirmation"
            element={<TeacherReplFormConfirmation />}
          />
          <Route path="completion" element={<TeacherCompletion />} />
        </Route>
      </Route>

      <Route path="/individual">
        <Route index element={<IndividualMain />} />
        <Route path="status" element={<TrackStatus mType={"individual"} />} />
        <Route path="app/new">
          <Route index element={<IndividualDeclaration appType={"new"} />} />
          <Route path="form" element={<IndividualNewForm />} />
          <Route
            path="confirmation"
            element={<IndividualNewFormConfirmation />}
          />
          <Route path="completion" element={<IndividualCompletion />} />
        </Route>
        <Route path="app/renew">
          <Route index element={<IndividualRenewLogin />} />
          <Route path="form" element={<IndividualRenewForm />} />
          <Route
            path="confirmation"
            element={<IndividualRenewFormConfirmation />}
          />
          <Route path="completion" element={<IndividualCompletion />} />
        </Route>
        <Route path="app/repl">
          <Route index element={<IndividualReplLogin />} />
          <Route path="form" element={<IndividualReplForm />} />
          <Route
            path="confirmation"
            element={<IndividualReplFormConfirmation />}
          />
          <Route path="completion" element={<IndividualCompletion />} />
        </Route>
      </Route>

      <Route path="/organisation">
        <Route index element={<OrganisationMain />} />
        <Route path="status" element={<TrackStatus mType={"organisation"} />} />
        <Route path="app/new">
          <Route index element={<OrganisationDeclaration appType={"new"} />} />
          <Route path="form" element={<OrganisationNewForm />} />
          <Route
            path="confirmation"
            element={<OrganisationNewFormConfirmation />}
          />
          <Route path="completion" element={<OrganisationCompletion />} />
        </Route>
        <Route path="app/renew">
          <Route index element={<OrganisationRenewLogin />} />
          <Route path="form" element={<OrganisationRenewForm />} />
          <Route
            path="confirmation"
            element={<OrganisationRenewFormConfirmation />}
          />
          <Route path="completion" element={<OrganisationCompletion />} />
        </Route>
        <Route path="app/repl">
          <Route index element={<OrganisationReplLogin />} />
          <Route path="form" element={<OrganisationReplForm />} />
          <Route
            path="confirmation"
            element={<OrganisationReplFormConfirmation />}
          />
          <Route path="completion" element={<OrganisationCompletion />} />
        </Route>
      </Route>

      <Route path="/school">
        <Route index element={<SchoolMain />} />
        <Route path="status" element={<TrackStatus mType={"school"} />} />
        <Route path="app/new">
          <Route index element={<SchoolDeclaration appType={"new"} />} />
          <Route path="form" element={<SchoolNewForm />} />
          <Route path="confirmation" element={<SchoolNewFormConfirmation />} />
          <Route path="completion" element={<SchoolCompletion />} />
        </Route>
        <Route path="app/renew">
          <Route index element={<SchoolRenewLogin />} />
          <Route path="form" element={<SchoolRenewForm />} />
          <Route
            path="confirmation"
            element={<SchoolRenewFormConfirmation />}
          />
          <Route path="completion" element={<SchoolCompletion />} />
        </Route>
        <Route path="app/repl">
          <Route index element={<SchoolReplLogin />} />
          <Route path="form" element={<SchoolReplForm />} />
          <Route path="confirmation" element={<SchoolReplFormConfirmation />} />
          <Route path="completion" element={<SchoolCompletion />} />
        </Route>
      </Route>
    </Routes>
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
